import React from "react";
import Joi from "joi-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import FormState from "./common/formstate";
import { register } from "../services/userService";
import { login } from "../services/authService";

class RegisterForm extends FormState {
  state = {
    data: {
      firstName: "",
      lastName: "",
      username: "",
      password: "",
      confirm_password: "",
      role: "",
    },
    errors: {},
  };

  schema = {
    username: Joi.string().required().email().label("Username"),
    password: Joi.string().required().min(5).label("Password"),
    confirm_password: Joi.string()
      .required()
      .valid(Joi.ref("password"))
      .options({
        language: {
          any: {
            allowOnly: "!!Passwords do not match",
          },
        },
      }),
    firstName: Joi.string().required().label("First Name"),
    lastName: Joi.string().required().label("Last Name"),
    role: Joi.string().required().label("Role"),
  };

  handleClearButton = () => {
    let data = {};
    data.firstName = "";
    data.lastName = "";
    data.username = "";
    data.password = "";
    data.confirm_password = "";
    data.role = "";
    this.setState({ data });
  };

  doSubmit = async () => {
    try {
      const { username, password } = this.state.data;

      //this.state.data.role = "user";
      await register(this.state.data);
      await login(username, password);
      window.location = "/";
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
      }
    }
  };

  render() {
    return (
      <div>
        <h4>
          <FontAwesomeIcon icon="user-circle" />
          &nbsp;Register
        </h4>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("username", "Email", "")}
          {this.renderInput("password", "Password", "", "password")}
          {this.renderInput(
            "confirm_password",
            "Confirm Password",
            "",
            "password"
          )}
          {this.renderInput("firstName", "First Name", "")}
          {this.renderInput("lastName", "Last Name", "")}
          {this.renderSelect(
            "role",
            "Role",
            [
              { value: "admin", text: "admin" },
              { value: "user", text: "user" },
              { value: "editor", text: "editor" },
            ],
            "value",
            "text"
          )}
          {this.renderButton("Register")}&nbsp;
          <Button variant="primary" onClick={() => this.handleClearButton()}>
            Clear
          </Button>
        </form>
      </div>
    );
  }
}

export default RegisterForm;
